module.exports = __webpack_public_path__ + "static/media/Cookie.a984236b.svg";